module.exports = __webpack_public_path__ + "img/sertifikat-1.c8c854be.jpg";